/* Verhalten des Themes. Bewusst klein gehalten: Navigation, Filter, Mengenfelder.
   Kein Framework, keine Abhängigkeiten. */
(function () {
  "use strict";

  function $(selector, root) {
    return (root || document).querySelector(selector);
  }

  function $$(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function toast(message) {
    var element = $("[data-toast]");
    if (!element) {
      return;
    }
    element.textContent = message;
    element.classList.add("toast--visible");
    window.clearTimeout(toast._timer);
    toast._timer = window.setTimeout(function () {
      element.classList.remove("toast--visible");
    }, 3600);
  }

  function initNav() {
    var toggle = $("[data-nav-toggle]");
    if (toggle) {
      toggle.addEventListener("click", function () {
        var open = document.body.classList.toggle("nav-open");
        toggle.setAttribute("aria-expanded", String(open));
      });
    }

  }

  function initFacets() {
    var form = $("[data-facets-form]");
    if (!form) return;
    var sectionId = form.dataset.sectionId;
    var feedback = $("[data-facet-feedback]");
    var controller, requestId = 0, loading = false;

    function closePanel() {
      document.body.classList.remove("filters-open");
      var toggle = $("[data-filters-toggle]", form);
      if (toggle) { toggle.setAttribute("aria-expanded", "false"); toggle.focus(); }
    }
    function enhance() {
      var toggle = $("[data-filters-toggle]", form);
      if (toggle) toggle.setAttribute("aria-expanded", String(document.body.classList.contains("filters-open")));
      var button = $("[data-filter-apply]", form);
      if (button) {
        button.textContent = form.dataset.productCount + (form.dataset.productCount === "1" ? " Produkt anzeigen" : " Produkte anzeigen");
        button.disabled = loading;
      }
    }
    function selectionUrl() {
      var url = new URL(window.location.href);
      url.pathname = new URL(form.action).pathname;
      Array.from(url.searchParams.keys()).forEach(function (key) {
        if (key.indexOf("filter.") === 0 || ["page", "sort_by", "section_id", "sections"].indexOf(key) !== -1) url.searchParams.delete(key);
      });
      new FormData(form).forEach(function (value, key) {
        if (String(value).trim() !== "") url.searchParams.append(key, value);
      });
      return url;
    }
    function showResults() {
      closePanel();
      $(".toolbar", form).scrollIntoView({block: "start"});
    }
    async function render(url, addHistory) {
      var id = ++requestId;
      if (controller) controller.abort();
      controller = new AbortController();
      loading = true;
      form.setAttribute("aria-busy", "true");
      if (feedback) feedback.textContent = "Auswahl wird aktualisiert.";
      enhance();
      var requestUrl = new URL(url);
      requestUrl.searchParams.set("section_id", sectionId);
      try {
        var response = await fetch(requestUrl.toString(), {signal: controller.signal});
        if (!response.ok) throw new Error("Filterantwort nicht verfügbar");
        var html = await response.text();
        if (id !== requestId) return false;
        var page = new DOMParser().parseFromString(html, "text/html");
        var next = $("[data-facets-form]", page);
        if (!next || next.dataset.sectionId !== sectionId) throw new Error("Filterabschnitt fehlt");

        // Zustand unmittelbar vor dem Austausch sichern: während des Ladens
        // dürfen weitere Häkchen gesetzt und das Panel gescrollt werden.
        var panel = $("[data-filters-panel]", form);
        var panelScroll = panel ? panel.scrollTop : 0;
        var focused = document.activeElement;
        var focusInForm = form.contains(focused);
        var focusKey = focusInForm ? {id: focused.id, name: focused.name, value: focused.value, close: focused.hasAttribute("data-filters-close")} : null;
        var groups = {};
        $$("[data-facet-key]", form).forEach(function (group) { groups[group.dataset.facetKey] = group.open; });
        form.innerHTML = next.innerHTML;
        form.dataset.productCount = next.dataset.productCount;
        $$("[data-facet-key]", form).forEach(function (group) {
          if (Object.prototype.hasOwnProperty.call(groups, group.dataset.facetKey)) group.open = groups[group.dataset.facetKey];
        });
        loading = false;
        enhance();
        if (panel) $("[data-filters-panel]", form).scrollTop = panelScroll;
        if (focusKey) {
          var target = $$("input, select, button, a", form).find(function (el) {
            if (focusKey.close) return el.hasAttribute("data-filters-close");
            if (focusKey.id) return el.id === focusKey.id;
            return focusKey.name && el.name === focusKey.name && el.value === focusKey.value;
          });
          if (target && !target.disabled) target.focus({preventScroll: true});
        }
        if (addHistory && url.href !== window.location.href) window.history.pushState({facets: true}, "", url);
        if (feedback) feedback.textContent = form.dataset.productCount + " passende Produkte. Filtermöglichkeiten aktualisiert.";
        return true;
      } catch (error) {
        if (id !== requestId || error.name === "AbortError") return false;
        // Bei Netz-/Renderingfehlern bleibt der native, serverseitige Weg erhalten.
        window.location.assign(url.toString());
        return false;
      } finally {
        if (id === requestId) {
          loading = false;
          form.removeAttribute("aria-busy");
          enhance();
        }
      }
    }

    // Delegation bleibt beim Austausch von Facetten, Chips und Ergebnissen aktiv.
    form.addEventListener("change", function (event) {
      if (!event.target.matches("input[type='checkbox'], input[type='number'], select[name='sort_by']")) return;
      if (form.checkValidity()) render(selectionUrl(), true);
    });
    form.addEventListener("submit", async function (event) {
      event.preventDefault();
      var url = selectionUrl();
      if (!loading && url.href === window.location.href) { showResults(); return; }
      if (await render(url, true)) showResults();
    });
    form.addEventListener("click", function (event) {
      var target = event.target.closest("[data-filters-toggle], [data-filters-close]");
      if (target) {
        if (target.hasAttribute("data-filters-close")) closePanel();
        else {
          var open = document.body.classList.toggle("filters-open");
          target.setAttribute("aria-expanded", String(open));
          if (open) $("[data-filters-close]", form).focus();
        }
        return;
      }
      var link = event.target.closest(".active-facets a, .facets__actions a, .empty-state a, .pagination a");
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var url = new URL(link.href);
      if (url.origin !== window.location.origin || url.pathname !== new URL(form.action).pathname) return;
      event.preventDefault();
      var isPage = !!link.closest(".pagination");
      render(url, true).then(function (done) { if (done && isPage) showResults(); });
    });
    form.addEventListener("keydown", function (event) {
      var panel = $("[data-filters-panel]", form);
      if (!panel.contains(event.target) || !window.matchMedia("(max-width: 759px)").matches || !document.body.classList.contains("filters-open")) return;
      if (event.key === "Escape") { event.preventDefault(); closePanel(); }
      if (event.key !== "Tab") return;
      var items = $$("button, a, input, select, summary", panel).filter(function (el) { return !el.disabled && el.getClientRects().length; });
      var first = items[0], last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    window.addEventListener("popstate", function () { render(new URL(window.location.href), false); });
    window.addEventListener("pageshow", function (event) {
      if (event.persisted) {
        closePanel();
        render(new URL(window.location.href), false);
      }
    });
    enhance();
  }

  function initProduct() {
    var root = $("[data-product-root]");
    if (!root) return;
    var data = $("[data-product-variants]", root);
    var variants = JSON.parse(data.textContent);
    var select = $("[data-variant-select]", root);
    var options = $$("[data-variant-option]", root);
    function pickedId() {
      var checked = $("[data-variant-option]:checked", root);
      return checked ? checked.value : select ? select.value : $("input[name='id']", root).value;
    }
    function pick(id) {
      if (select) select.value = String(id);
      options.forEach(function (option) { option.checked = option.value === String(id); });
    }
    var initialVariantId = pickedId();
    var mainImage = $("[data-product-image]", root);
    var originalImage = root.dataset.seriesImage || (mainImage && mainImage.src);
    var originalSrcset = root.dataset.seriesSrcset || (mainImage && mainImage.srcset);
    function updateVariant(updateUrl) {
      var id = pickedId();
      var variant = variants.find(function (v) { return String(v.id) === String(id); });
      if (!variant) return;
      var selectedName = $("[data-selected-variant]", root);
      if (selectedName) selectedName.textContent = variant.title;
      var price = $("[data-product-price]", root);
      price.textContent = variant.price;
      if (variant.compare) {
        var was = document.createElement("span");
        was.className = "price--was"; was.textContent = variant.compare;
        price.appendChild(was);
      }
      $("[data-sticky-price]", root).textContent = variant.price;
      $("[data-product-sku]", root).textContent = variant.sku;
      $$("[data-product-add]", root).forEach(function (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? "In den Warenkorb" : "Ausverkauft";
      });
      if (mainImage) {
        mainImage.src = variant.image || originalImage;
        mainImage.srcset = variant.image ? variant.imageSrcset : originalSrcset;
        mainImage.alt = root.dataset.productTitle + " – " + (variant.image ? variant.title : "Serienfoto");
        mainImage.width = variant.image ? variant.imageWidth : Number(root.dataset.seriesWidth);
        mainImage.height = variant.image ? variant.imageHeight : Number(root.dataset.seriesHeight);
        var zoomImage = $("[data-lightbox-image]", root);
        zoomImage.src = mainImage.src;
        zoomImage.alt = mainImage.alt;
        zoomImage.width = mainImage.width;
        zoomImage.height = mainImage.height;
        $("[data-image-caption]", root).textContent = variant.image ? "Produktfoto: " + variant.title + "." : "Für diese Auswahl ist noch kein eigenes Farbfoto vorhanden. Du siehst das Serienfoto.";
      }
      $$("[data-lifestyle-sku]", root).forEach(function (scene) { scene.hidden = scene.dataset.lifestyleSku !== variant.sku; });
      $("[data-variant-status]", root).textContent = variant.title + ", " + variant.price + (variant.available ? "" : ", ausverkauft");
      if (updateUrl) {
        var url = new URL(window.location.href); url.searchParams.set("variant", variant.id);
        window.history.pushState({variant: variant.id}, "", url);
      }
    }
    if (select || options.length) {
      if (select) select.addEventListener("change", function () { updateVariant(true); });
      options.forEach(function (option) { option.addEventListener("change", function () { if (option.checked) updateVariant(true); }); });
      window.addEventListener("popstate", function () {
        var id = new URL(window.location.href).searchParams.get("variant");
        if (id && variants.some(function (v) { return String(v.id) === id; })) pick(id);
        else pick(initialVariantId);
        updateVariant(false);
      });
    }
    updateVariant(false);
    var lightbox = $("[data-product-lightbox]", root);
    var zoom = $("[data-product-zoom]", root);
    if (zoom && lightbox && lightbox.showModal) {
      zoom.addEventListener("click", function () { lightbox.showModal(); });
      $("[data-lightbox-close]", root).addEventListener("click", function () { lightbox.close(); });
      lightbox.addEventListener("click", function (event) { if (event.target === lightbox) lightbox.close(); });
    }
    var sticky = $("[data-sticky-buy]", root);
    var buy = $("[data-buy-row]", root);
    if (sticky && buy && window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
      }, {rootMargin: "-80px 0px 0px 0px"}).observe(buy);
    }
  }

  function initQuantity() {
    $$("[data-quantity]").forEach(function (host) {
      var input = $("input", host);
      if (!input) {
        return;
      }
      var minus = $("[data-quantity-minus]", host);
      var plus = $("[data-quantity-plus]", host);
      if (minus) {
        minus.addEventListener("click", function () {
          input.value = Math.max(parseInt(input.min, 10) || 1, (parseInt(input.value, 10) || 1) - 1);
        });
      }
      if (plus) {
        plus.addEventListener("click", function () {
          var max = parseInt(input.max, 10) || 99;
          input.value = Math.min(max, (parseInt(input.value, 10) || 1) + 1);
        });
      }
    });
  }

  function initCart() {
    var root = $("[data-cart-root]");
    if (!root || !window.fetch || !window.DOMParser) return;
    var feedback = $("[data-cart-feedback]", root);
    var cartUrl = root.dataset.cartUrl;
    var sectionId = root.dataset.sectionId;
    var busy = false;

    function message(text, error) {
      feedback.textContent = text;
      feedback.classList.toggle("is-error", !!error);
    }
    function lock(value) {
      busy = value;
      if (value) root.setAttribute("aria-busy", "true");
      else root.removeAttribute("aria-busy");
      $$("button, input, textarea", root).forEach(function (element) {
        if (value) {
          element.dataset.cartWasDisabled = element.disabled ? "true" : "false";
          element.disabled = true;
        } else if (element.dataset.cartWasDisabled !== undefined) {
          element.disabled = element.dataset.cartWasDisabled === "true";
          delete element.dataset.cartWasDisabled;
        }
      });
      $$("[data-cart-remove]", root).forEach(function (link) {
        if (value) link.setAttribute("aria-disabled", "true");
        else link.removeAttribute("aria-disabled");
      });
    }
    function render(html, lineIndex, action, note) {
      if (!html) throw new Error("Warenkorbabschnitt fehlt");
      var page = new DOMParser().parseFromString(html, "text/html");
      var next = $("[data-cart-root]", page);
      if (!next || next.dataset.sectionId !== sectionId) throw new Error("Warenkorbabschnitt ungültig");
      $("[data-cart-content]", root).innerHTML = $("[data-cart-content]", next).innerHTML;
      var nextNote = $("[name='note']", root);
      if (nextNote && note !== undefined) nextNote.value = note;
      var lines = $$("[data-cart-line]", root);
      var line = lines[Math.min(lineIndex - 1, lines.length - 1)];
      var target = line && (action === "remove" ? $("[data-cart-quantity]", line) : $("[data-cart-step='" + action + "']", line));
      if (!target || target.disabled) target = line ? $("[data-cart-quantity]", line) : $("a", $("[data-cart-content]", root));
      if (target) target.focus({preventScroll: true});
    }
    function updateCount(count) {
      $$(".cart-count").forEach(function (badge) {
        badge.textContent = count;
        badge.setAttribute("aria-label", count + " Artikel im Warenkorb");
        var link = badge.closest("a");
        if (link) link.setAttribute("aria-label", "Warenkorb – " + count + " Artikel im Warenkorb");
      });
    }
    async function change(input, quantity, action) {
      if (busy) return;
      if (!Number.isSafeInteger(quantity) || quantity < 0 || (action === "input" && !input.checkValidity())) {
        input.reportValidity();
        message("Bitte eine ganze Anzahl ab 0 eingeben.", true);
        return;
      }
      if (quantity === Number(input.dataset.quantity)) return;
      var line = input.closest("[data-cart-line]");
      var lineIndex = Number(line.dataset.line);
      var noteInput = $("[name='note']", root);
      var note = noteInput ? noteInput.value : undefined;
      // Immer den frisch gerenderten Schlüssel verwenden: Rabatte können ihn ändern.
      var key = line.dataset.cartKey;
      var customerError = "";
      lock(true);
      message(quantity === 0 ? "Artikel wird entfernt …" : "Warenkorb wird aktualisiert …");
      try {
        var response = await fetch(cartUrl + "/change.js", {
          method: "POST", headers: {"Content-Type": "application/json", "Accept": "application/json"},
          body: JSON.stringify({id: key, quantity: quantity, sections: [sectionId], sections_url: cartUrl})
        });
        var cart = await response.json();
        if (!response.ok) {
          customerError = typeof cart.description === "string" ? cart.description : "Diese Menge ist derzeit nicht verfügbar.";
          throw new Error("Mengenänderung abgelehnt");
        }
        updateCount(cart.item_count);
        render(cart.sections && cart.sections[sectionId], lineIndex, action, note);
        var total = $("[data-cart-total]", root);
        message(quantity === 0 ? "Artikel entfernt." : "Menge aktualisiert." + (total ? " Gesamt " + total.textContent.trim() + "." : ""));
      } catch (error) {
        // Eine fehlende Antwort bedeutet nicht, dass die Änderung fehlgeschlagen ist.
        // Daher niemals die Mutation wiederholen; zuerst den Serverstand neu lesen.
        try {
          var url = new URL(cartUrl, window.location.origin);
          url.searchParams.set("section_id", sectionId);
          var refreshed = await fetch(url.toString(), {cache: "no-store"});
          if (!refreshed.ok) throw new Error("Warenkorb nicht erreichbar");
          render(await refreshed.text(), lineIndex, action, note);
          // Kopfzählung und Warenkorb bei uneindeutiger Antwort gemeinsam synchronisieren.
          var count = $$("[data-cart-quantity]", root).reduce(function (sum, element) { return sum + Number(element.value); }, 0);
          updateCount(count);
          message(customerError || "Die Änderung konnte nicht bestätigt werden. Dein aktueller Warenkorb wurde neu geladen. Bitte versuche es erneut.", true);
        } catch (refreshError) {
          window.location.assign(cartUrl);
        }
      } finally {
        lock(false);
      }
    }
    root.addEventListener("click", function (event) {
      var button = event.target.closest("[data-cart-step], [data-cart-remove]");
      if (!button) return;
      event.preventDefault();
      if (busy || button.disabled) return;
      var input = $("[data-cart-quantity]", button.closest("[data-cart-line]"));
      var remove = button.hasAttribute("data-cart-remove");
      var step = button.dataset.cartStep;
      var quantity = remove ? 0 : Math.max(1, Number(input.dataset.quantity) + Number(step));
      change(input, quantity, remove ? "remove" : step);
    });
    root.addEventListener("change", function (event) {
      if (event.target.matches("[data-cart-quantity]")) change(event.target, event.target.valueAsNumber, "input");
    });
    root.addEventListener("keydown", function (event) {
      if (event.key === "Enter" && event.target.matches("[data-cart-quantity]")) {
        event.preventDefault();
        change(event.target, event.target.valueAsNumber, "input");
      }
    });
    root.addEventListener("submit", function (event) {
      if (busy) { event.preventDefault(); return; }
      // Checkout bleibt das native Formular; nur Mengen-Eingaben abfangen.
      if (event.submitter && event.submitter.name === "checkout") return;
      var input = $$("[data-cart-quantity]", root).find(function (element) { return element.value !== element.dataset.quantity; });
      event.preventDefault();
      if (input) change(input, input.valueAsNumber, "input");
    });
    root.classList.add("cart--enhanced");
    message("Änderungen werden automatisch übernommen.");
    window.addEventListener("pageshow", function (event) {
      if (event.persisted) window.location.reload();
    });
  }

  function initNewsletter() {
    var success = $("[data-newsletter-success]");
    if (success) {
      toast(success.getAttribute("data-newsletter-success"));
    }
  }

  function init() {
    // Alte geteilte Farbfilter-URLs auf die serverseitige Variantenfacette führen.
    if (document.querySelector('[data-facets-form]')) {
      var filterUrl = new URL(window.location.href);
      var oldColorKey = 'filter.p.m.outdoorkissen.farbfamilien';
      var newColorKey = 'filter.v.m.outdoorkissen.farbfamilien';
      var oldColors = filterUrl.searchParams.getAll(oldColorKey);
      if (oldColors.length) {
        oldColors.forEach(function (color) {
          if (filterUrl.searchParams.getAll(newColorKey).indexOf(color) === -1) {
            filterUrl.searchParams.append(newColorKey, color);
          }
        });
        filterUrl.searchParams.delete(oldColorKey);
        window.location.replace(filterUrl.toString());
        return;
      }
    }
    initNav();
    initFacets();
    initQuantity();
    initCart();
    initProduct();
    initNewsletter();
    document.documentElement.classList.remove("no-js");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
